export default "\r\n<app-alergy-type-list></app-alergy-type-list>\r\n\r\n\r\n";